import { useLanding } from "@/context/LandingContext";
import { InteractiveSection, MotionBg } from "./MotionBg";
import { Reveal } from "./Reveal";

function SpeakerCard({ person, duo, dates, index }) {
  const variant = duo ? "duo" : "solo";
  return (
    <Reveal as="article" className={`speaker-card ${variant}`} tilt delay={index * 0.1} data-testid={duo ? `speaker-card-${person.id}` : "speaker-card"}>
      <div className="speaker-top">
        <div className="speaker-visual">
          {person.portrait ? (
            <img className={`speaker-portrait ${person.portraitFit || ""}`} src={person.portrait} alt={person.name} loading="lazy" decoding="async" data-testid={`speaker-portrait-${person.id}`} />
          ) : (
            <div className="speaker-avatar" aria-hidden="true">{person.initials}</div>
          )}
        </div>
        <div className="speaker-tags">
          <span className="speaker-tag">{person.tag}</span>
          {dates && <span className="speaker-dates" data-testid={`speaker-dates-${person.id}`}>{dates}</span>}
        </div>
      </div>
      <div>
        <h3 data-testid={duo ? `speaker-name-${person.id}` : "speaker-name"}>{person.name}</h3>
        <div className="speaker-role">{person.role}</div>
        <span className="speaker-rnf">{person.rnf}</span>
        <p className="speaker-bio">{person.bio}</p>
        <div className="speaker-focus" aria-label="Webinar topics">
          {person.focus.map((topic) => (
            <span key={topic}>{topic}</span>
          ))}
        </div>
      </div>
    </Reveal>
  );
}

export function Speaker() {
  const { t, lang, events } = useLanding();
  const s = t.speaker;
  const duo = s.people.length > 1;
  const datesFor = (id) => {
    const shorts = events.filter((event) => event.speakerId === id).map((event) => event.short[lang]);
    if (!shorts.length) return "";
    return `${shorts.join(" & ")}${shorts.length > 1 ? s.sessionSuffix.many : s.sessionSuffix.one}`;
  };
  return (
    <InteractiveSection className="section" id="speakers" data-testid="speaker-section">
      <MotionBg variant="spotlight" dots={3} />
      <div className="container">
        <Reveal className="section-head center">
          <p className="eyebrow"><span className="eyebrow-no">07</span>{s.eyebrow}</p>
          <h2>{s.title}</h2>
          <p className="subhead">{s.lead}</p>
        </Reveal>
        <div className={`speaker-grid ${duo ? "duo" : ""}`} data-testid="speaker-grid">
          {s.people.map((person, index) => (
            <SpeakerCard key={person.id} person={person} duo={duo} dates={duo ? datesFor(person.id) : ""} index={index} />
          ))}
        </div>
      </div>
    </InteractiveSection>
  );
}

export function MidCta() {
  const { t } = useLanding();
  return (
    <InteractiveSection className="mid-cta" data-testid="mid-cta">
      <MotionBg variant="shimmer" />
      <div className="container mid-cta-inner">
        <h2>{t.mid.title}</h2>
        <a className="btn btn-dark" href="#register" data-testid="mid-cta-btn">
          {t.mid.button} <span className="arrow">→</span>
        </a>
      </div>
    </InteractiveSection>
  );
}
